import {useLocation,useNavigate} from 'react-router-dom';
import {useKeycloak} from '@react-keycloak/web';
import {Badge,Box,Paper,BottomNavigation,BottomNavigationAction} from '@mui/material';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import CoreFooter from '../../core/components/Footer';
import {useApplication} from './ApplicationContext.js';
import {useNotifications} from './Notification/NotificationsContext';
import ConsumerThemeProvider,{isConsumer} from './ConsumerTheme.js';

// Consumers (athletes) get an app-like bottom navigation instead of the
// staff footer (role + login line). Routes are still server-filtered per role
// (AppMenu), this only changes how the consumer moves between their screens.
export const CONSUMER_BOTTOM_NAV_HEIGHT=64;

const CONSUMER_TABS=[
    {value:'new',path:'/my_analysis/new',label:'ButtonNewAnalysisRequest',Icon:AddCircleRoundedIcon,match:(p)=>p.startsWith('/my_analysis/new')},
    {value:'analyses',path:'/my_analyses',label:'ScreenMyAnalyses',Icon:ListAltRoundedIcon,match:(p)=>p.startsWith('/my_analys')},
    {value:'notifications',path:'/my_notifications',label:'TooltipNotifications',Icon:NotificationsRoundedIcon,match:(p)=>p.startsWith('/my_notification')},
    {value:'profile',path:'/my_user',label:'UserMenuProfile',Icon:AccountCircleRoundedIcon,match:(p)=>p.startsWith('/my_user')},
];
const TAB_ORDER=['analyses','new','notifications','profile'];

function ConsumerBottomNav(){
    const navigate=useNavigate();
    const {pathname}=useLocation();
    const {globalData}=useApplication();
    const {unread}=useNotifications();
    const current=CONSUMER_TABS.find((tab)=>tab.match(pathname))?.value??false;

    return (
        <>
            {/* In-flow spacer so the last content on a page can scroll above the fixed bar */}
            <Box sx={{height:`calc(${CONSUMER_BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom))`}}/>
            <Paper
                elevation={8}
                square
                sx={{position:'fixed',bottom:0,left:0,right:0,zIndex:1000,pb:'env(safe-area-inset-bottom)'}}>
                <BottomNavigation
                    showLabels
                    value={current}
                    onChange={(_,value)=>navigate(CONSUMER_TABS.find((tab)=>tab.value===value).path)}
                    sx={{height:CONSUMER_BOTTOM_NAV_HEIGHT}}>
                    {TAB_ORDER.map((value)=>{
                        const {label,Icon}=CONSUMER_TABS.find((tab)=>tab.value===value);
                        const icon=value==='notifications'
                            ?<Badge color="secondary" badgeContent={unread} max={99}><Icon/></Badge>
                            :<Icon/>;
                        return <BottomNavigationAction key={value} value={value} label={globalData?.getLocale(label)} icon={icon}/>;
                    })}
                </BottomNavigation>
            </Paper>
        </>
    );
}

function Footer({userData}){
    const {keycloak}=useKeycloak();
    const {globalData}=useApplication();

    if(keycloak.authenticated&&globalData&&isConsumer(userData)){
        return (
            <ConsumerThemeProvider userData={userData} backdrop>
                <ConsumerBottomNav/>
            </ConsumerThemeProvider>
        );
    }
    return <CoreFooter userData={userData}/>;
}
export default Footer;
